import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IWorldDial } from 'app/schedule/schedule-details/_models/world-dial.interface';

@Injectable()
export class WorldCountriesService {
  constructor(protected _http: HttpClient) {}

  /**
   * Gets the list of all dial codes
   */
  getWorlDialCodes(): Observable<IWorldDial[]> {
    return this._http.get('/assets/world-countries/data/pt/dial.json').pipe(
      map((response: any) => {
        response.forEach((elem) => {
          elem.label = `${elem.label} ${elem.value}`;
        });

        return response;
      })
    );
  }
}
